module.exports = __webpack_public_path__ + "img/absorbente16.9b47adf1.jpg";